import { connect } from 'react-redux';
import TenantUsers from '../../../components/tenantUsers/TenantUsers';
import {profile, tenantUsers, loading, errorMessage} from 'core/selectors';
import {
  getTenantUsers,
  createTenantUser,
  updateTenantUser,
  deleteTenantUser,
} from 'core/slices/tenantUsers';

export default connect(
  state => ({
    profile: profile(state),
    tenantUsers: tenantUsers(state),
    loading: loading(state),
    errorMessage: errorMessage(state),
  }),
  { getTenantUsers, createTenantUser, updateTenantUser, deleteTenantUser },
)(TenantUsers);